// src/utils/transform.ts

// Transformation constants
const COS_60 = 0.5; // Math.cos(Math.PI / 3)
const COS_30 = 0.866 // Math.sqrt(3) / 2; // Math.cos(Math.PI / 6)
const SIN_30 = 0.5; // Math.sin(Math.PI / 6)

interface Point {
  x: number;
  y: number;
}
function getAngleInDegrees(x:number, y:number):number {
  const radians = Math.atan2(y, x);
  // Convert radians to degrees
  const degrees = radians * (180 / Math.PI);
  return degrees;
}


/**
 * Transforms 2D world coordinates (from mockAPI data) to 
 * the 2D plane as it appears on the screen after the 3D rotation.
 * This does NOT include canvas panning or zooming.
 * @param worldX - The x-coordinate from the data.
 * @param worldY - The y-coordinate from the data.
 * @returns {Point} The transformed coordinates on the rotated screen plane.
 */
export const toScreenPlane = (worldX: number, worldY: number): Point => {
    
    const y2 = worldX * SIN_30 + worldY * COS_30;
    const x2 = worldX * COS_30 - worldY * SIN_30;

    const y1 = y2 * COS_60;

    /*
  const x_s = worldX * COS_30 - (worldY * COS_60) * SIN_30;
  const y_s = worldX * SIN_30 + (worldY * COS_60) * COS_30;
  */

  return { x: x2, y: y1 };
};

/**
 * Transforms 2D screen plane coordinates (a point on the rotated plane)
 * back to the original 2D world coordinates (mockAPI data).
 * This is the inverse of toScreenPlane.
 * @param screenX - The x-coordinate on the rotated screen plane.
 * @param screenY - The y-coordinate on the rotated screen plane.
 * @returns {Point} The original world coordinates.
 */
export const toWorld = (screenX: number, screenY: number): Point => {
  const x_prime = screenX * COS_30 + screenY * SIN_30;
  const y_prime = -screenX * SIN_30 + screenY * COS_30;
  
  const x_m = x_prime;
  const y_m = y_prime / COS_60;
  return { x: x_m, y: y_m };
};